import React from 'react'

import './common-footer.scss'

const CommonFooter = () => (
  <footer className="common-footer">
    <span>Find me elsewhere:</span>
    <ul>
      <li><a href="https://twitter.com/DingoEatingFuzz" target="_blank" rel="noopenner noreferrer">Twitter</a></li>
      <li><a href="https://github.com/DingoEatingFuzz" target="_blank" rel="noopenner noreferrer">Github</a></li>
    </ul>
  </footer>
)

export default CommonFooter
